import React from 'react';
import L33tPage from './components/L33tPage';

const L33tRoute = () => {
  return <L33tPage />;
};

export default L33tRoute;
